module.exports = __webpack_public_path__ + "img/s5bg.3ac706f9.webp";